import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  /** Rendered element — use "li" when the reveal sits directly inside a list. */
  as?: 'div' | 'li';
}

/** Fade + subtle rise once, when the element first enters the viewport. */
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const Component = as === 'li' ? motion.li : motion.div;
  return <Component className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-269" data-mp="2jst0gy2kggx6">
      {children}
    </Component>;
}